function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { toIndianRs } from "../../../../../utils/helpers";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function Bag(_ref) {
  var cartValue = _ref.cartValue,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    isPoints = _ref.isPoints;
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var dealAction = redux === null || redux === void 0 ? void 0 : redux.dealAction;
  var _useState = useState(-2),
    _useState2 = _slicedToArray(_useState, 2),
    deleteIndex = _useState2[0],
    setDeleteIndex = _useState2[1];
  var onClickHandleDeleteCart = function onClickHandleDeleteCart(index) {
    setDeleteIndex(index);
  };
  var onDeleteCart = function onDeleteCart(item, itemId) {
    var _window, _ref2, _ref3, _dealsState$isRefresh;
    (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("RemoveFromCartClicked", {
      ProductName: "".concat(item === null || item === void 0 ? void 0 : item.title),
      Price: "".concat(item === null || item === void 0 ? void 0 : item.productMrp),
      PointsRequired: "".concat(item === null || item === void 0 ? void 0 : item.points)
    });
    var oldCartData = isPoints ? localStorage.getItem("cartData_reloyrewardpoints") : localStorage.getItem("cartData");
    if (!oldCartData) return;
    var cartData = JSON.parse(oldCartData);

    // Find the item to remove based on `itemId`
    var itemIndex = cartData.cartValues.findIndex(function (item) {
      return item.id === itemId;
    });
    if (itemIndex === -1) return; // Item not found, do nothing

    // Get the item to remove for updating totalMrp
    var itemToRemove = cartData.cartValues[itemIndex];

    // Remove the item from cartValues
    cartData.cartValues.splice(itemIndex, 1);

    // Update totalMrp and totalProduct
    cartData.totalMrp -= itemToRemove.productMrp;
    cartData.totalPoints -= itemToRemove.points;
    cartData.totalShippingFee -= itemToRemove.productShippingFee;
    cartData.totalConvenienceFee -= itemToRemove.productConvenienceFee;
    cartData.totalProduct -= 1;
    setDeleteIndex(-2);

    // Save updated cart data to localStorage
    if (isPoints) {
      localStorage.setItem("cartData_reloyrewardpoints", JSON.stringify(cartData));
    } else {
      localStorage.setItem("cartData", JSON.stringify(cartData));
    }
    // Dispatch a custom event to notify other components
    window.dispatchEvent(new Event("cartUpdated"));
    var dealsState = (redux === null || redux === void 0 ? void 0 : redux.deals) || (redux === null || redux === void 0 ? void 0 : redux.deal) || {};
    var isRefresh = !((_ref2 = (_ref3 = (_dealsState$isRefresh = dealsState === null || dealsState === void 0 ? void 0 : dealsState.isRefreshRewards) !== null && _dealsState$isRefresh !== void 0 ? _dealsState$isRefresh : dealsState === null || dealsState === void 0 ? void 0 : dealsState.isRewardRefreshing) !== null && _ref3 !== void 0 ? _ref3 : redux === null || redux === void 0 ? void 0 : redux.isRefreshRewards) !== null && _ref2 !== void 0 ? _ref2 : redux === null || redux === void 0 ? void 0 : redux.isRewardRefreshing);
    // Skip the rewards re-fetch for the coin store (isPoints) flow. The points
    // list is not filtered by affordability (see getRewards in
    // DealsAndDiscounts/data.js), so re-fetching after removing an item does no
    // useful work and, because that flow appends results, it duplicates the
    // products. Other flows still refresh normally.
    if (!isPoints && dispatch && dealAction !== null && dealAction !== void 0 && dealAction.setIsRewardRefreshing) {
      dispatch(dealAction.setIsRewardRefreshing(isRefresh));
    }
  };
  console.log("cartValue", cartValue);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: " flex flex-col  lg:px-0 lg:justify-center pb-2",
      children: [/*#__PURE__*/_jsx("h1", {
        className: "font-bold text-base",
        children: "Product Details"
      }), /*#__PURE__*/_jsx("div", {
        className: "max-h-[57vh] md:max-h-[60vh] 2xl:max-h-[70vh] overflow-y-scroll scrollbar-thin  lg:scrollbar-hide",
        children: /*#__PURE__*/_jsx("div", {
          className: "flex-grow p-2 space-y-4",
          children: cartValue.map(function (cart, index) {
            return /*#__PURE__*/_jsxs("div", {
              className: "relative items-start pb-2    border-b border-gray-200",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "flex flex-row gap-3 ",
                children: [/*#__PURE__*/_jsx("div", {
                  className: "flex flex-col   min-w-max items-start",
                  children: /*#__PURE__*/_jsx("img", {
                    src: cart !== null && cart !== void 0 && cart.thumbnailImageUrl ? cart === null || cart === void 0 ? void 0 : cart.thumbnailImageUrl : cart === null || cart === void 0 ? void 0 : cart.displayImageUrl,
                    alt: "Product Image",
                    className: "w-24 h-24 lg:w-20 lg:h-20 object-cover cursor-pointer"
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: "flex flex-col  gap-1   justify-center flex-grow ",
                  children: [/*#__PURE__*/_jsx("p", {
                    className: "font-semibold text-sm text-black",
                    children: cart === null || cart === void 0 ? void 0 : cart.title
                  }), /*#__PURE__*/_jsx("p", {
                    className: "text-primary text-base font-bold",
                    children: isPoints ? "".concat(Number((cart === null || cart === void 0 ? void 0 : cart.points) || 0).toLocaleString("en-IN"), " Points") : toIndianRs(cart === null || cart === void 0 ? void 0 : cart.productMrp)
                  })]
                }), /*#__PURE__*/_jsx("div", {
                  className: "sm:w-[10%] flex justify-center mr-1.5",
                  children: /*#__PURE__*/_jsx("button", {
                    onClick: function onClick() {
                      return onClickHandleDeleteCart(index);
                    },
                    className: "text-red-500  p-1 rounded-full transition",
                    children: /*#__PURE__*/_jsx("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "32",
                      height: "32",
                      viewBox: "0 0 26 26",
                      children: /*#__PURE__*/_jsxs("g", {
                        id: "Group_12543",
                        "data-name": "Group 12543",
                        transform: "translate(-1310 -69)",
                        children: [/*#__PURE__*/_jsx("rect", {
                          id: "Rectangle_17370",
                          "data-name": "Rectangle 17370",
                          width: "26",
                          height: "26",
                          rx: "5",
                          transform: "translate(1310 69)",
                          fill: "#ecedf6"
                        }), /*#__PURE__*/_jsxs("g", {
                          id: "delete-93",
                          transform: "translate(1315.333 76)",
                          children: [/*#__PURE__*/_jsx("path", {
                            id: "Path_6546",
                            "data-name": "Path 6546",
                            d: "M146.465,149.1H141.6a1.893,1.893,0,0,1-1.89-1.892v-7.564h8.643v7.564A1.894,1.894,0,0,1,146.465,149.1Zm-6.213-8.914v7.022a1.352,1.352,0,0,0,1.35,1.351h4.863a1.351,1.351,0,0,0,1.35-1.351V140.19Z",
                            transform: "translate(-136.443 -138.027)",
                            fill: "red",
                            stroke: "red",
                            "stroke-width": "0.5"
                          }), /*#__PURE__*/_jsx("path", {
                            id: "Path_6547",
                            "data-name": "Path 6547",
                            d: "M352.964,2.163h-3.78V1.082A1.082,1.082,0,0,1,350.263,0h1.621a1.081,1.081,0,0,1,1.079,1.082Zm-3.24-.542h2.7V1.082a.54.54,0,0,0-.54-.54h-1.62a.541.541,0,0,0-.54.54Z",
                            transform: "translate(-343.484)",
                            fill: "red",
                            stroke: "red",
                            "stroke-width": "0.5"
                          }), /*#__PURE__*/_jsx("path", {
                            id: "Path_6548",
                            "data-name": "Path 6548",
                            d: "M13.262,140.19H1.918a.272.272,0,0,1,0-.542H13.262a.271.271,0,0,1,0,.542ZM7.59,146.672a.272.272,0,0,1-.271-.27v-4.593a.271.271,0,0,1,.542,0V146.4A.272.272,0,0,1,7.59,146.672Zm-2.161-.54a.272.272,0,0,1-.271-.27V142.35a.271.271,0,0,1,.542,0v3.511a.27.27,0,0,1-.27.27Zm4.051,0a.27.27,0,0,1-.268-.27V142.35a.27.27,0,0,1,.539,0v3.511a.271.271,0,0,1-.271.27Z",
                            transform: "translate(0 -138.027)",
                            fill: "red",
                            stroke: "red",
                            "stroke-width": "0.5"
                          })]
                        })]
                      })
                    })
                  })
                })]
              }, index), index === deleteIndex && /*#__PURE__*/_jsxs("div", {
                className: "flex flex-col justify-center absolute inset-0 bg-white bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50",
                children: [/*#__PURE__*/_jsx("div", {
                  className: "flex justify-center items-center mb-4"
                }), /*#__PURE__*/_jsx("p", {
                  className: "text-center text-sm font-semibold text-black-600 mb-4",
                  children: "Remove item from Gift Basket?"
                }), /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center justify-center gap-6 mb-4",
                  children: [/*#__PURE__*/_jsx("button", {
                    className: "bg-white border border-primary text-sm text-primary px-4 py-2 rounded-lg",
                    onClick: function onClick() {
                      return setDeleteIndex(-2);
                    },
                    children: "No"
                  }), /*#__PURE__*/_jsx("button", {
                    className: "bg-primary text-white text-sm px-4 py-2 rounded-lg ",
                    onClick: function onClick() {
                      return onDeleteCart(cart, cart === null || cart === void 0 ? void 0 : cart.id);
                    },
                    children: "Yes"
                  })]
                })]
              })]
            });
          })
        })
      })]
    })
  });
}
export default Bag;